import React from 'react';

export class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error(`[Kindra] Page crash in ${this.props.name || 'unknown'}:`, error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="page-error-boundary"
          className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center"
        >
          <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <p className="text-base font-semibold text-slate-800 mb-1">Something went wrong</p>
          <p className="text-sm text-slate-500 mb-6 max-w-xs">
            We hit a problem loading this page. Please refresh or try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2.5 bg-[#235347] text-white text-sm font-medium rounded-full hover:bg-[#1A3F36] transition-colors"
          >
            Refresh page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
